import { takeData } from '../../../shared/misc';
import { decompressValue } from './utils';

export const fetchProduction = async (coreSettings) => {
  const req = new Request(
    `${window.location.origin}/cms-settings/${coreSettings.event_id}_vmRevolution_false.json`
  );
  return fetch(req).then(takeData).then(decompressValue);
};
